import React, { FC } from 'react';
import { TypeConditionalBannerFields } from '@/core/generated-types';
import { BackgroundColorWrapper } from '@/components/common/BackgroundColorWrapper';
import { UniversalCta } from '@/components';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';

interface BannerPresentationProps extends TypeConditionalBannerFields {
  testId?: string;
}
const BannerPresentation: FC<BannerPresentationProps> = (fields) => {
  const { title, description, backgroundColor, cta } = fields;
  return (
    <BackgroundColorWrapper color={backgroundColor?.fields.color}>
      <div
        className="my-10 flex flex-col items-start justify-center gap-1 rounded-md px-5 py-7 shadow-md lg:flex-row lg:items-center lg:gap-5 lg:px-10 lg:py-9"
        data-testid={fields.testId || 'banner'}
      >
        <Heading
          text={title}
          tag={HeadingTag.H3}
          size={HeadingSize.H3}
          align="left"
          classes="basis-1/4"
        />
        <p className="mb-2 basis-2/4 lg:mb-0 lg:text-lg">{description}</p>
        <UniversalCta link={cta} className="h-fit lg:ml-2 lg:mr-3" />
      </div>
    </BackgroundColorWrapper>
  );
};

export default React.memo(BannerPresentation);
